/** User reducer actions */
export const USERS_ACTIONS = {
  LOADING: "loading",
  ERROR: "error",
  USERS: "users",
  LIST_FILTERS: "list_filters",
};
